// Holds tracking calls made before the visitor's consent decision is known,
// so they can be sent once it is granted or dropped once it is refused.

const DEFAULT_MAX_PENDING = 20;

export interface ConsentQueue<T> {
	push: (item: T) => void;
	/** Sends everything queued through `send`, or drops it when `send` is undefined. */
	flush: (send: ((item: T) => void) | undefined) => void;
}

export const createConsentQueue = <T>(
	maxPending = DEFAULT_MAX_PENDING
): ConsentQueue<T> => {
	let pending: T[] = [];

	return {
		push: (item) => {
			pending = [...pending, item].slice(-maxPending);
		},
		flush: (send) => {
			const queued = pending;
			pending = [];
			if (send) queued.forEach((item) => send(item));
		}
	};
};
